import { useEffect, useState } from 'react';
import api from '../services/api';

// Catálogo de avatares ativos (GET /api/avatars), buscado uma vez por página e
// compartilhado por todos os AvatarUsuario e pelo seletor do Perfil.
let promessa = null;
let catalogo = null;
const ouvintes = new Set();

const carregar = () => {
  if (!promessa) {
    // Promise.resolve: um api.get que devolva algo que não é promessa (mocks dos
    // testes) vira só "catálogo vazio", nunca erro de renderização.
    promessa = Promise.resolve()
      .then(() => api.get('/avatars'))
      .then((resposta) => {
        const data = resposta?.data;
        const lista = Array.isArray(data) ? data : [];
        catalogo = { lista, porId: new Map(lista.map((a) => [Number(a.id), a])) };
        ouvintes.forEach((f) => f(catalogo));
        return catalogo;
      })
      .catch((err) => {
        // Sem catálogo todo mundo aparece com as iniciais; tenta de novo no próximo uso.
        promessa = null;
        throw err;
      });
  }
  return promessa;
};

const VAZIO = { lista: [], porId: new Map() };

const useCatalogoAvatares = () => {
  const [estado, setEstado] = useState(catalogo || VAZIO);
  const [carregando, setCarregando] = useState(!catalogo);

  useEffect(() => {
    let vivo = true;
    const atualizar = (c) => { if (vivo) { setEstado(c); setCarregando(false); } };
    ouvintes.add(atualizar);
    if (catalogo) atualizar(catalogo);
    else carregar().catch(() => { if (vivo) setCarregando(false); });
    return () => { vivo = false; ouvintes.delete(atualizar); };
  }, []);

  return { avatares: estado.lista, porId: estado.porId, carregando };
};

// Só para os testes.
export const __limparCatalogoAvatares = () => { promessa = null; catalogo = null; ouvintes.clear(); };

export default useCatalogoAvatares;
